var map = {
	"./00001.png": 1624,
	"./00002.png": 1499,
	"./00003.png": 1603,
	"./00004.png": 9189,
	"./00005.png": 9331,
	"./00006.png": 2100,
	"./00007.png": 8620,
	"./1091500.png": 8772,
	"./271590.png": 1389,
	"./271591.png": 3130,
	"./79709895.png": 8219,
	"./79709896.png": 6491,
	"./adobereader.png": 6396,
	"./amongus.png": 3154,
	"./instagram.png": 9147,
	"./leagueoflegends.png": 2872,
	"./needforspedheat.png": 2302,
	"./netflix.png": 9325,
	"./netflixsmall.png": 9974,
	"./portal2.png": 9018,
	"./powerpoint.png": 9504,
	"./shazam.png": 5470,
	"./skyrim.png": 1034,
	"./undefined.png": 2541,
	"./whatsapp.png": 708,
	"./witcher3.png": 7923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3190;